import React from 'react';
import HeroHeader from '../components/HeroHeader';

function AboutSection() {
  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="assets/img/about.jpg"
                alt="Premium boat rentals and on-site repairs in Cape Coral"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>

          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            <h6 className="section-title bg-white text-start text-primary pe-3">
              About Us
            </h6>
            <h1 className="mb-4">
              Premium <span className="text-primary">Boat Rentals</span> & <span className="text-primary">Repairs</span> in Cape Coral
            </h1>

            <p className="mb-4">
                At <strong>Sunbay Boats</strong>, we make exploring Cape Coral’s waterways effortless with a premium rental fleet and on-demand repairs that keep you moving.
            </p>

            <p className="mb-4">
                From family sandbar trips to dockside service, we provide expert care, fair pricing, and local knowledge you can trust.
            </p>

            <div className="row gy-2 gx-4 mb-4">
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-anchor text-primary me-2" />
                  Newer, clean & comfortable fleet
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-clock text-primary me-2" />
                  Half-day, full-day & multi-day rentals
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-life-ring text-primary me-2" />
                  Safety briefings & local route tips
                </p>
              </div>
              <div className="col-sm-6">
                <p className="mb-0">
                  <i className="fa fa-dollar-sign text-primary me-2" />
                  Upfront, no-surprise pricing
                </p>
              </div>
            </div>

            {/* Trust badges / quick stats */}
            <div className="d-flex flex-wrap gap-3 mb-4">
              <span className="badge bg-light text-dark py-2 px-3">
                Cape Coral • Matlacha • Pine Island
              </span>
            </div>

            {/* Primary CTAs */}
            <div className="d-flex flex-wrap gap-3">
              <a href="/Contact" className="btn btn-primary rounded-pill py-3 px-4">
                Book a Rental
              </a>
              <a href="/Contact" className="btn btn-outline-primary rounded-pill py-3 px-4">
                Request Repair (Coming Soon)
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutSection;
